module.exports = __webpack_public_path__ + "img/swift-boostergreen-glx-amarillo-ocaso.6e93a8f0.png";